import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { format } from 'date-fns';
import { Notificacion } from '../models/notificacion';
import { ParamsPlantilla } from '../models/paramsplantilla';
import { AppConfigService } from './config/app.config.service';
import { Vwnotificacion } from '../models/vwnotificacion';


@Injectable({ providedIn: 'root' })
export class NotificacionService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private confServ: AppConfigService) { }

  getNotificacions(activa: number, fechaIni: Date, fechaFin: Date): Observable<Vwnotificacion[]> {
    let params = new HttpParams();

    if (activa != null) {
      params = params.append('activa', activa ? 1 : 0);
    }

    if (fechaIni != null && fechaFin != null) {
      params = params.append('fechaini', format(fechaIni, 'dd/MM/yyyy'));
      params = params.append('fechafin', format(fechaFin, 'dd/MM/yyyy'));
    }

    return this.http.get<Vwnotificacion[]>(`${this.confServ.getConfig().apiUrl}/notificaciones`, { params: params });
  }

  getNotificacion(id: number): Observable<Notificacion> {
    const url = `${this.confServ.getConfig().apiUrl}/notificaciones/id/${id}`;
    return this.http.get<Notificacion>(url);
  }

  addNotificacion(params: ParamsPlantilla): Observable<Notificacion> {
    return this.http.post<ParamsPlantilla>(`${this.confServ.getConfig().apiUrl}/notificaciones`, params, this.httpOptions);
  }

  deleteNotificacion(id: number): Observable<Notificacion> {
    const url = `${this.confServ.getConfig().apiUrl}/notificaciones/id/${id}`;
    return this.http.delete<Notificacion>(url, this.httpOptions);
  }

  updateNotificacion(notificacion: Vwnotificacion): Observable<any> {
    return this.http.put(`${this.confServ.getConfig().apiUrl}/notificaciones`, notificacion, this.httpOptions);
  }


}
